import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { AUTOMATION_PLATFORM_FLOW_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
export const GET_CUSTOM_WORKFLOW_PROPERTIES = registerQuery({
  fieldName: 'customWorkflowProperties',
  args: [],
  fetcher: () => {
    return http.get(`crm-object-fields/v2/fields/${AUTOMATION_PLATFORM_FLOW_ID}/creator`).then(workflowProperties => workflowProperties.filter(({
      type
    }) => type === 'PROPERTY').map(({
      identifier,
      required
    }) => ({
      propertyName: identifier,
      isRequired: required
    })));
  }
});